import { ReactNode } from 'react';

import MuiPopover, {
  PopoverProps as MuiPopoverProps,
} from '@mui/material/Popover';

/**
 * Пропсы универсального Popover-компонента {@link Popover}.
 * Наследует все стандартные пропсы MUI Popover и требует children.
 */
export interface PopoverProps extends MuiPopoverProps {
  /**
   * Содержимое, которое будет отображено внутри поповера
   */
  children: ReactNode;
}

/**
 * Универсальный Popover-компонент для UI-библиотеки.
 * Обёртка над MUI Popover, принимает все стандартные пропсы Popover и children для отображения содержимого.
 *
 * @public
 * @param children - Дочерние элементы, которые будут отображены внутри компонента Paper.
 * @returns  Компонент Popover.
 *
 * @example
 *
 * ```
 * <Popover open={open} anchorEl={anchorEl} onClose={handleClose}>
 *   <div>Контент поповера</div>
 * </Popover>
 * ```
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link PopoverProps}
 */
export const Popover = ({ children, ...props }: PopoverProps) => (
  <MuiPopover {...props}>{children}</MuiPopover>
);
